class AdpTintController {
  constructor() {
    this.name = 'adpTint';
  }
}

export default AdpTintController;



// WEBPACK FOOTER //
// ./src/app/components/adpTint/adpTint.controller.js